import request from '@/utils/request'
import { praseStrEmpty } from '@/utils/util'

// 查询用户列表
export function listUser(query) {
  return request({
    url: '/admi/user/list',
    method: 'get',
    params: query
  })
}

// 查询用户详细
export function getUser(userId) {
  return request({
    url: '/admi/user/' + praseStrEmpty(userId),
    method: 'get'
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/admi/user',
    method: 'post',
    data: data
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/admi/user',
    method: 'put',
    data: data
  })
}

// 删除用户
export function delUser(userId) {
  return request({
    url: '/admi/user/' + userId,
    method: 'delete'
  })
}

// 导出用户
export function exportUser(query) {
  return request({
    url: '/admi/user/export',
    method: 'get',
    params: query
  })
}

// 用户密码重置
export function resetUserPwd(userId, password) {
  const data = {
    userId,
    password
  }
  return request({
    url: '/admi/user/resetPwd',
    method: 'put',
    data: data
  })
}

// 用户状态修改
export function changeUserStatus(userId, status) {
  const data = {
    userId,
    status
  }
  return request({
    url: '/admi/user/changeStatus',
    method: 'put',
    data: data
  })
}

// 查询用户档案信息
export function getUserProfileInfor(userId) {
  return request({
    url: '/admi/archives/' + userId,
    method: 'get'
  })
}

// 保存用户档案信息
export function addUserProfileInfor(data) {
  return request({
    url: '/admi/archives',
    method: 'put',
    data
  })
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/admi/user/profile',
    method: 'get'
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/admi/user/profile',
    method: 'put',
    data: data
  })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/admi/user/profile/updatePwd',
    method: 'put',
    params: data
  })
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/admi/user/profile/avatar',
    method: 'post',
    data: data
  })
}

// 下载用户导入模板
export function importTemplate() {
  return request({
    url: '/admi/user/importTemplate',
    method: 'get'
  })
}

// 同步企业微信获取部门成员详情
export function syncQyWxUser() {
  return request({
    url: '/admi/user/syncQyWxAdd',
    method: 'post'
  })
}

// 查询部门用户个人信息
export function selectDeptIdByUserList(deptId) {
  return request({
    url: '/system/user/selectDeptIdByUserList/' + deptId,
    method: 'get'
  })
}

// 公告通知列表
export function listNotice(query) {
  return request({
    url: '/system/notice/list',
    method: 'get',
    params: query,
    options: {
      loading: true
    }
  })
}
// 公告通知详情
export function getNotice(noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'get',
    options: {
      loading: true
    }
  })
}

// 查询用户待办列表
export function listBacklog(query) {
  return request({
    url: '/admi/backlog/list',
    method: 'get',
    params: query,
    options: {
      loading: true
    }
  })
}
// 查询用户待办数量
export function getCountItem(query) {
  return request({
    url: '/admi/backlog/getCountItem',
    method: 'get',
    params: query
  })
}

// 查询用户是否有未认领收款
export function getNoGetIncomeCount(data) {
  return request({
    url: '/cont/newIncome/getNoGetIncomeCount',
    method: 'post',
    data: data
  })
}
